console.log('✅ login-user-options-top.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, watchAppState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

//let _tempTextTranslator = null;
//export async function initTempTextTranslator(lang) {
//  _tempTextTranslator = await loadTextTranslations(lang);
//}

//let _tempLinksTranslator = null;
//export async function initTempLinksTranslator(lang) {
//  _tempLinksTranslator = await initLinksTranslator(lang);
//}

//const lang = appState.SiteLanguageCookie;

export async function buildComponentLoginUserOptionsSidebar() {
 // console.log(`🔄 Building Component: LoginUserOptionsSidebar - lang: ${lang}`);


   try {
            const skeleton = await buildPageSkeleton();

            //By calling registerEventListenerToAttach() immediately, you wire up your hydration callback without delaying the paint.

            //registerEventListenerToAttach(async () => initbuildComponentPageAccountPersonalAddress(params));
            registerEventListenerToAttach(initbuildComponentLoginUserOptionsSidebar);

            if (!isNodeEnvironment()) return skeleton;

            return await buildActualContent();

            return html;
       



    
   
  } catch (err) {
    console.error('❌ Error building LoginUserOptionsSidebar:', err);
    return '<div>Error loading user options</div>';
  }
}

export async function buildPageSkeleton() {
    // Top two “featured” cards
    const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

    let middleCardsSkeleton = '';
    for (let i = 0; i < 12; i++) {
        middleCardsSkeleton += `
      <div class="grid-blog-home-all-category-section-card my-fake-image-height-400">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        
    `;
    }

    const html = `

    <div id="placeholder-LoginUserOptionsSidebar">
  
   
    <center>

    <div class="myPageMargins">
       

                 ${middleCardsSkeleton}
       
    </div>

    </center>


     </div> 
    
   
  `;

    return html;
}


//@if (_myUserIdentityInformationService.MyBuyingEntityType == "Business") {

           

//            <a href="@linkBusinessMail" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessMail
//               </a>
//            <a href="@linkBusinessChats" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessChat
//            </a>
//            <a href="@linkDashboard" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessDashboard
//               </a>

//            <a href="@linkBusinessOrders" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessOrders
//            </a>

//            <a href="@linkBusinessReturns" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessReturns
//               </a>

//            <a href="@linkMyRegisteredCompany" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessDetails
//            </a>



//            <a href="@linkBusinessAddresses" onclick="closeNavSidePanelUserOptions(this);">
//               @lblTradingAddresses
//               </a>


//            <a href="@linkMyPaymentMethods" onclick="closeNavSidePanelUserOptions(this);">
//               </a>

//            <a href="@linkBusinessWishlist" onclick="closeNavSidePanelUserOptions(this);">
//               @lblBusinessWishlist </a>

//            <a href="@linkCreateBusinessQuoteRequest" onclick="closeNavSidePanelUserOptions(this);">
//                @lblCreateBusinessQuoteRequest
//            </a>

//            <a href="@linkBusinessQuotes" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessQuotes
//               </a>

         

//            <a href="@linkBusinessPreviousPurchases" onclick="closeNavSidePanelUserOptions(this);">
//                @lblPreviouslyPurchased
//               </a>

//            <a href="@linkBusinessProductReviews" onclick="closeNavSidePanelUserOptions(this);">
//                @lblProductReviews
//               </a>

//            <a href="@linkBusinessRecentlyViewedProducts" onclick="closeNavSidePanelUserOptions(this);">
//                @lblRecentlyViewed
//               </a>

//            <a href="@linkMyStore" onclick="closeNavSidePanelUserOptions(this);">
//               @lblCompanyStore
//               </a>

            

//            <a href="@linkMyCompanies" onclick="closeNavSidePanelUserOptions(this);">
//               @lblAllMyCompanies
//               </a>

//            <a href="@linkMyCompanyUsers" onclick="closeNavSidePanelUserOptions(this);">
//               @lblCompanyUsers
//               </a>

//            <a href="@linkMyCompanyUserRoles" onclick="closeNavSidePanelUserOptions(this);">
//               @lblCompanyUserRoles
//               </a>


//            <a href="@linkBusinessNewsletterSubscription" onclick="closeNavSidePanelUserOptions(this);">
//                @lblNewsletterSubscription
//               </a>

//            <a href="@linkBusinessSettings" onclick="closeNavSidePanelUserOptions(this);">
//                @lblBusinessSettings
//            </a>





//            <a href="@linkSelectProfile" onclick="closeNavSidePanelUserOptions(this);">
//               @lblChangeProfile
//               </a>

//            <a href="logout" onclick="closeNavSidePanelUserOptions(this);">
//               @lblLogout
//               </a>




//}
//else {






//            <a href="@linkMyMessages" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMessages
//               </a>

//            <a href="@linkDashboard" onclick="closeNavSidePanelUserOptions(this);">
//               @lblDashboard
//               </a>

//            <a href="@linkMyOrders" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyOrders 
//           </a>

//            <a href="@linkMyReturns" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyReturns
//               </a>

//            <a href="@linkMyDetails" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyDetails 
//           </a>

//            <a href="@linkMyAddresses" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyAddresses 
//           </a>


//            <a href="@linkMyPaymentMethods" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyPaymentMethods 
//           </a>

//            <a href="@linkMyWishlist" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyWishlist 
//           </a>
//            <a href="@linkCreateQuoteRequest" onclick="closeNavSidePanelUserOptions(this);">
//                @lblCreateQuoteRequest
//            </a>


//            <a href="@linkMyQuotes" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyQuotes
//               </a>

//            <a href="@linkMyTenders" onclick="closeNavSidePanelUserOptions(this);">
//               @lblMyTenders
//               </a>

//            <a href="@linkMyPreviousPurchases" onclick="closeNavSidePanelUserOptions(this);">
//               @lblPreviouslyPurchased
//               </a>

//            <a href="@linkMyProductReviews" onclick="closeNavSidePanelUserOptions(this);">
//               @lblProductReviews
//               </a>

//            <a href="@linkMyRecentlyViewedProducts" onclick="closeNavSidePanelUserOptions(this);">
//               @lblRecentlyViewed 
//           </a>
//            <a href="@linkMyNewsletterSubscription" onclick="closeNavSidePanelUserOptions(this);">
//                @lblNewsletterSubscription
//            </a>

//            <a href="@linkMySettings" onclick="closeNavSidePanelUserOptions(this);">
//                @lblMySettings
//            </a>


           

//            <a href="@linkMyPasswordReset">
//               @lblResetPassword
//               </a>

//    @if (_myUserIdentityInformationService.UserHasAtLeastOneBuyingCompanyAccess) {

//        <a href="@linkSelectProfile" onclick="closeNavSidePanelUserOptions(this);">
//            @lblChangeProfile
//        </a>

//    }

//    <a href="logout" onclick="closeNavSidePanelUserOptions(this);">
//        @lblLogout
//    </a>



//}
//        </div >


export async function buildActualContent() {


  //  alert(`buildActualContent called for LoginUserOptionsSidebar`);

    const { loadMyTranslationsService } = await import(
        /* webpackChunkName: "translation-service" */
        /* webpackPrefetch: true */
        '../../services/my-translator-service.js'
    );

    const {
        _tempTextTranslator: tTexts,
        _tempLinksTranslator: tLinks,
       // _tempFragmentsTranslator: tFrags
    } = await loadMyTranslationsService(appState.SiteLanguageCookie);

    //let fragTermsAndConditions = tFrags.keyFragRegisterPageIAcceptTermsAndConditions;
    //fragTermsAndConditions = fragTermsAndConditions
    //    .replaceAll('KeyFragLinkPrivacyPolicy', tLinks.keyPrivacyPolicy)
    //    .replaceAll('KeyFragLinkTermsAndCondition', tLinks.keyTermsAndConditions)


    let html = `  `;


    if (!appState.MyUserIsAuthenticated) {



        html = `

         <div class="SideNavLinksWrapper">


        <a href="${tLinks.keyLogin}" class="SideNavFooterBtnLikeLinksACTIVE" data-close-on-click>
           ${tTexts.keySignIn}
           </a>


        <a href="${tLinks.keyRegister}" id="linkRegisterMobile" class="SideNavFooterBtnLikeLinks" data-close-on-click>
            ${tTexts.keyRegister}
        </a>
    </div>


           
        `;
    }
    else {
        html = `

         <div class="divTopLanguageWrapper-Button">

        
          ${tTexts.keyHello}, ${appState.MyUserFirstName} ${appState.MyUserLastName}

          ${appState.MyBuyingEntityType === 'Business' ? `${tTexts.keyOnBehalfOf} ${appState.MyBuyingEntityCompanyName}`
                : ''
          }
                 
    </div>


      <div class="SideNavLinksWrapper">

      
          ${appState.MyBuyingEntityType === 'Business'
            ? `    <a data-close-on-click href="${tLinks.keyBusinessMail}">${tTexts.keyBusinessMail}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessChats}">${tTexts.keyBusinessChats}</a>
                   <a data-close-on-click href="${tLinks.keyDashboard}">${tTexts.keyBusinessDashboard}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessOrders}">${tTexts.keyBusinessOrders}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessReturns}">${tTexts.keyBusinessReturns}</a>
                   <a data-close-on-click href="${tLinks.keyMyRegisteredCompany}">${tTexts.keyBusinessDetails}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessAddresses}">${tTexts.keyTradingAddresses}</a>
                   <a data-close-on-click href="${tLinks.keyMyPaymentMethods}">${tTexts.keyMyPaymentMethods}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessWishlist}">${tTexts.keyBusinessWishlist}</a>
                   <a data-close-on-click href="${tLinks.keyCreateBusinessQuoteRequest}">${tTexts.keyCreateBusinessQuoteRequest}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessQuotes}">${tTexts.keyBusinessQuotes}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessPreviousPurchases}">${tTexts.keyBusinessPreviouslyPurchased}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessProductReviews}">${tTexts.keyProductReviews}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessRecentlyViewedProducts}">${tTexts.keyRecentlyViewed}</a>
                   <a data-close-on-click href="${tLinks.keyMyStore}">${tTexts.keyCompanyStore}</a>
                   <a data-close-on-click href="${tLinks.keyMyCompanies}">${tTexts.keyAllMyCompanies}</a>
                   <a data-close-on-click href="${tLinks.keyMyCompanyUsers}">${tTexts.keyCompanyUsers}</a>
                   <a data-close-on-click href="${tLinks.keyMyCompanyUserRoles}">${tTexts.keyCompanyUserRoles}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessNewsletterSubscription}">${tTexts.keyNewsletterSubscription}</a>
                   <a data-close-on-click href="${tLinks.keyBusinessSettings}">${tTexts.keyBusinessSettings}</a>
                   <a data-close-on-click href="${tLinks.keySelectProfile}">${tTexts.keyChangeProfile}</a>
                   <a data-close-on-click href="${tLinks.keyLogout}">${tTexts.keyLogout}</a>


                     
               
              `
            :

              `    <a data-close-on-click href="${tLinks.keyMyMessages}">${tTexts.keyMessages}</a>
                   <a data-close-on-click href="${tLinks.keyDashboard}">${tTexts.keyDashboard}</a>
                   <a data-close-on-click href="${tLinks.keyMyOrders}">${tTexts.keyMyOrders}</a>
                   <a data-close-on-click href="${tLinks.keyMyReturns}">${tTexts.keyMyReturns}</a>
                   <a data-close-on-click href="${tLinks.keyMyDetails}">${tTexts.keyMyDetails}</a>
                   <a data-close-on-click href="${tLinks.keyMyAddresses}">${tTexts.keyMyAddresses}</a>
                   <a data-close-on-click href="${tLinks.keyMyPaymentMethods}">${tTexts.keyMyPaymentMethods}</a>
                   <a data-close-on-click href="${tLinks.keyMyWishlist}">${tTexts.keyMyWishlist}</a>
                   <a data-close-on-click href="${tLinks.keyCreateQuoteRequest}">${tTexts.keyCreateQuoteRequest}</a>
                   <a data-close-on-click href="${tLinks.keyMyQuotes}">${tTexts.keyMyQuotes}</a>
                   <a data-close-on-click href="${tLinks.keyMyTenders}">${tTexts.keyMyTenders}</a>
                   <a data-close-on-click href="${tLinks.keyMyPreviousPurchases}">${tTexts.keyPreviouslyPurchased}</a>
                   <a data-close-on-click href="${tLinks.keyMyProductReviews}">${tTexts.keyProductReviews}</a>
                   <a data-close-on-click href="${tLinks.keyMyRecentlyViewedProducts}">${tTexts.keyRecentlyViewed}</a>
                   <a data-close-on-click href="${tLinks.keyMyNewsletterSubscription}">${tTexts.keyNewsletterSubscription}</a>
                   <a data-close-on-click href="${tLinks.keyMySettings}">${tTexts.keyMySettings}</a>
                   <a data-close-on-click href="${tLinks.keyMyPasswordReset}">${tTexts.keyResetPassword}</a>
                      

                    ${appState.UserHasAtLeastOneBuyingCompanyAccess
                    ? `<a data-close-on-click href="${tLinks.keySelectProfile}">${tTexts.keyChangeProfile}</a>`
                    : ''  
                    }

                    <a data-close-on-click href="${tLinks.keyLogout}">${tTexts.keyLogout}</a>
                 

               `
            }
         



      </div>
    `;
    }


    return html;

}


export async function initbuildComponentLoginUserOptionsSidebar() {
    try {

        const container = document.querySelector('#placeholder-LoginUserOptionsSidebar');
        if (!container) return;



        //This touches only the <div id="placeholder-…"> subtree. The rest of the page (header, footer, global scripts) is completely untouched, so the browser can preserve layout and styles. *** FYI Only - innerHTML result in the browser reflowing the entire page, which is expensive.
        //container.outerHTML = await buildActualContent();
        container.innerHTML = await buildActualContent(); // innerHTML keeps the node intact



    //const loginButton = document.querySelector(".loginUserOptionsLink");
    //const registerButton = document.querySelector(".btnTopSignIn-RegisterBtn");
    //const dropdown = document.querySelector("#loginUserOptionsDropdown");
    //let isDropdownOpen = false;

    //const toggleDropdown = () => {
    //    isDropdownOpen = !isDropdownOpen;
    //    dropdown.style.display = isDropdownOpen ? "block" : "none";
    //};

    //// Attach event listener to login button
    //loginButton?.addEventListener("click", () => toggleDropdown());

    //// Close the dropdown when clicking outside
    //document.addEventListener("click", (event) => {
    //    if (!dropdown?.contains(event.target) && !loginButton?.contains(event.target)) {
    //        dropdown.style.display = "none";
    //        isDropdownOpen = false;
    //    }
    //});

    console.log('✅ LoginUserOptionsSidebar event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to LoginUserOptionsSidebar:', error);
  }
}






async function refreshWholeComponent() {

    //   alert(`updateHeaderForUser called with isAuthenticated: ${isAuthenticated}`);

    await buildComponentLoginUserOptionsSidebar();
    await initbuildComponentLoginUserOptionsSidebar();


}


let IsAttachedWatchAppState = false;

if (!IsAttachedWatchAppState) {
    watchAppState('MyUserIsAuthenticated', refreshWholeComponent);
    IsAttachedWatchAppState = true;
}
